"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startStream = exports.injectStreamToDom = void 0;
var http_1 = require("../helpers/http");
var index_1 = require("../index");
var helpers_1 = require("../helpers/helpers");
var messages_1 = require("../constants/messages");
var core_1 = require("./core");
/**
 * Inject the video into the DOM
 *
 * @param url URL of the stream returned from HTTP Gateway Server
 * @param videoDomQuery an injection point for the video. Should be a `div`.  If found the content will be removed before loading. If not set will do nothing and let client handle video playback.
 */
var injectStreamToDom = function (url, videoDomQuery, videoOptions) {
    if (videoOptions === void 0) { videoOptions = {}; }
    var injectPoint = document.querySelector(videoDomQuery);
    if (!injectPoint) {
        (0, helpers_1.errorLog)(messages_1.messages.streamInjectDomInvalid, { query: videoDomQuery });
        return;
    }
    // Empty DOM inject point
    while (injectPoint.firstChild) {
        injectPoint.removeChild(injectPoint.firstChild);
    }
    var video = document.createElement('video');
    video.classList.add('aspera-http-gateway-video');
    video.controls = true;
    if (videoOptions.controls !== undefined) {
        video.controls = videoOptions.controls;
    }
    if (videoOptions.autoplay !== undefined) {
        video.autoplay = videoOptions.autoplay;
    }
    if (videoOptions.loop !== undefined) {
        video.loop = videoOptions.loop;
    }
    if (videoOptions.muted !== undefined) {
        video.muted = videoOptions.muted;
    }
    if (videoOptions.poster !== undefined) {
        video.poster = videoOptions.poster;
    }
    if (videoOptions.height !== undefined) {
        video.height = videoOptions.height;
    }
    if (videoOptions.width !== undefined) {
        video.width = videoOptions.width;
    }
    else {
        video.setAttribute('style', 'width: 100%;');
    }
    injectPoint.appendChild(video);
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url;
        video.addEventListener('loadedmetadata', function () {
            video.play();
        });
    }
    else if (window.Hls.isSupported()) {
        var hls = new window.Hls();
        hls.loadSource(url);
        hls.attachMedia(video);
        hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
            video.play();
        });
    }
};
exports.injectStreamToDom = injectStreamToDom;
/**
 * Start a HTTP Gateway video. stream.  transferSpec is ONLY accepted if contains ONE file.
 *
 * It is recommended to add this https://cdn.jsdelivr.net/npm/hls.js to your project
 *
 * @param transferSpec standard Connect transferSpec for downloading
 * @param videoDomQuery an injection point for the video. Should be a `div`.  If found the content will be removed before loading. If not set will do nothing and let client handle video playback.
 *
 * @returns a promise that resolves if stream is started successfully or rejects if error occurs
 */
var startStream = function (transferSpec, videoDomQuery, videoOptions) {
    if (videoOptions === void 0) { videoOptions = {}; }
    if (!index_1.asperaHttpGateway.isReady) {
        (0, helpers_1.errorLog)(messages_1.messages.serverNotVerified);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.serverNotVerified));
        });
    }
    if (!(0, helpers_1.isValidTransferSpec)(transferSpec)) {
        (0, helpers_1.errorLog)(messages_1.messages.notValidTransferSpec);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.notValidTransferSpec, { transferSpec: transferSpec }));
        });
    }
    if (transferSpec.paths.length !== 1) {
        (0, helpers_1.errorLog)(messages_1.messages.streamingTooManyFiles);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.streamingTooManyFiles, { transferSpec: transferSpec }));
        });
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_spec: transferSpec
    };
    var finalServerUrl = videoOptions.serverUrlOverride ? (0, core_1.cleanupServerUrl)(videoOptions.serverUrlOverride) : index_1.asperaHttpGateway.globals.serverUrl;
    // TODO: what is the URL made of. Assuming same as download but with /stream endpoint.  Simpler if just get back direct URL.
    (0, http_1.apiPost)("".concat(finalServerUrl, "/v1/start-stream"), payload).then(function (response) {
        response.json().then(function (data) {
            if (data.transfer_spec_id) {
                var streamUrl = "".concat(finalServerUrl, "/v1/stream/").concat(data.transfer_spec_id, "/").concat(data.transfer_spec_id, ".m3u8");
                if (index_1.asperaHttpGateway.globals.softwareMode) {
                    promiseInfo.resolver({
                        transfer_spec_id: data.transfer_spec_id,
                        url: streamUrl,
                    });
                    return;
                }
                if (videoDomQuery) {
                    (0, exports.injectStreamToDom)(streamUrl, videoDomQuery, videoOptions);
                }
                promiseInfo.resolver();
            }
            else {
                (0, helpers_1.errorLog)(messages_1.messages.failedToGetStreamUrl, { response: data });
                promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.failedToGetStreamUrl, { response: data }));
            }
        });
    }).catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.streamFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.streamFailed, error));
    });
    return promiseInfo.promise;
};
exports.startStream = startStream;
exports.default = {
    startStream: exports.startStream,
    injectStreamToDom: exports.injectStreamToDom
};
